import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import generalStyles from './style/general.module.css';
import sizeStyles from './style/size.module.css';

export default function Card({
  bgColor = '',
  children,
  size = 'medium',
  withBorder = false,
  withBorderRadius = false,
  withMargin = true,
  withShadow = false,
}) {
  if (!children) return null;

  const cardClassName = cx(generalStyles.card, sizeStyles[size], {
    [generalStyles.withMargin]: withMargin,
    [generalStyles.border]: withBorder,
    [generalStyles.borderRadius]: withBorderRadius,
    [generalStyles.shadow]: withShadow,
  });

  const cardStyle = bgColor ? { backgroundColor: bgColor } : {};

  return (
    <div className={cardClassName} style={cardStyle}>
      {children}
    </div>
  );
}

Card.propTypes = {
  bgColor: PropTypes.string,
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(Object.keys(sizeStyles)),
  withBorder: PropTypes.bool,
  withBorderRadius: PropTypes.bool,
  withMargin: PropTypes.bool,
  withShadow: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/modules/Card/index.js